import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as yup from 'yup';

import { TeacherForm } from "./forms/teacher-form";

const validationSchema = yup.object({
  firstName: yup
    .string('Ingrese el nombre')
    .required('El nombre es obligatorio'),
  lastName: yup
    .string('Ingrese el Apellido')
    .required('El apellido es obligatorio'),
  surname: yup
    .string('Ingrese el Apellido')
    .required('El apellido es obligatorio'),
  fullName: yup
    .string('Ingrese el nombre y apellido')
    .required('El nombre y apellido es obligatorio'),
  dni: yup
  .string('Debe ingresar un número')
  .matches(/^[0-9]+$/, "Ingresa solo numeros")
  .min(8, "Debes ingresar 8 digitos")
  .max(8, "Debes ingresar 8 digitos")
  .required('El DNI es obligatorio'),
});

export const TeacherDialog = ({open, customer, closeModal, saveCustomer, searchDni}) => {

  return (
    <Dialog open={open} maxWidth="sm" fullWidth={true} scroll="paper">
      <Formik
        initialValues={customer}
        onSubmit={
          (values) => {
            saveCustomer(values);
          }
        }
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => (
          <Form >
            <DialogTitle>
              Nuevo Profesor
            </DialogTitle>
            <DialogContent>
              <TeacherForm {...props} searchDni={searchDni}  />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeModal} variant="outlined">
                Cancelar
              </Button>
              <Button type="submit" variant="contained">
                Guardar
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

